import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { TomosSection } from './components/TomosSection';
import { BonusesSection } from './components/BonusesSection';
import { TargetAudienceSection } from './components/TargetAudienceSection';
import { ComparisonSection } from './components/ComparisonSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', '1252698209555498');
      f.fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-white text-gray-800 font-sans selection:bg-brand-200 selection:text-brand-900" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainPointsSection data-id="element-3" />
        <TomosSection data-id="element-4" />
        <BonusesSection data-id="element-5" />
        <TargetAudienceSection data-id="element-6" />
        <ComparisonSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FaqSection data-id="element-11" />
        <FinalCtaSection data-id="element-12" />
      </main>

      <footer className="bg-brand-50 py-8 text-center border-t border-brand-100" data-id="element-13">
        <p className="text-gray-500 text-sm" data-id="element-14">
          © {new Date().getFullYear()} Mega Pack Electricidad en Casa. Todos
          los derechos reservados.
        </p>
      </footer>

      <SocialProofPopup data-id="element-15" />
    </div>;
}